import { Component, Input, OnInit } from '@angular/core';
import { Banners } from 'app/services/app-settings.types';
import { FileUploader } from 'app/settings/types';
import { LogoUploader } from 'app/entities/event/logo-uploader';

@Component({
  selector: 'ad-banner-multi-editor',
  templateUrl: 'ad-banner-multi-editor.html',
  standalone: false
})
export class AdBannerMultiEditorComponent implements OnInit {
  @Input() adDefinition: Banners;
  @Input() uploader: LogoUploader;
  selectedTabIndex: number = 0;
  smallImageUploader: FileUploader;
  largeImageUploader: FileUploader;

  ngOnInit() {
    this.smallImageUploader = (file, progressCallback) => {
      return this.uploader(file, 'sm', progressCallback);
    };

    this.largeImageUploader = (file, progressCallback) => {
      return this.uploader(file, 'lg', progressCallback);
    };
  }
}
